import React from 'react';
import { Banner, Button, Dialog, DialogContent, DialogFooter, DialogTrigger, Spinner, Tabs, Tab, TabList, TabPanel } from '@chatsdet/ui';
import { useApiRequestOccurrence } from '../../../features/api-catalog/api';
import { JsonBlock } from './JsonBlock';
import { formatDateTime } from '../../../features/api-catalog/components/shared';

export const ErrorOccurrenceDialog: React.FC<{
  requestId: string;
  occurrenceId: string | null;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}> = ({ requestId, occurrenceId, isOpen, onOpenChange }) => {
  const occurrenceQuery = useApiRequestOccurrence(requestId, occurrenceId, isOpen);
  const occurrence = occurrenceQuery.data?.data ?? null;

  if (!occurrenceId) return null;

  return (
    <DialogTrigger isOpen={isOpen} onOpenChange={onOpenChange} size="lg">
      <button style={{ display: 'none' }} />
      <Dialog
        title={
          occurrence
            ? `HTTP ${typeof occurrence.statusCode === 'number' ? occurrence.statusCode : '—'} details`
            : 'Occurrence details'
        }
        description={occurrence ? formatDateTime(occurrence.seenAt) : undefined}
      >
        <DialogContent className="space-y-6">
          {occurrenceQuery.isLoading && (
            <div className="flex items-center justify-center py-12">
              <Spinner size="md" />
            </div>
          )}
          {occurrenceQuery.isError && (
            <Banner variant="error">
              {occurrenceQuery.error instanceof Error
                ? occurrenceQuery.error.message
                : 'Failed to load occurrence details.'}
            </Banner>
          )}
          {occurrence && (
            <Tabs>
              <TabList aria-label="Error details">
                <Tab id="request">Request</Tab>
                <Tab id="response">Response</Tab>
              </TabList>
              <TabPanel id="request" className="pt-4">
                <div className="space-y-6">
                  <JsonBlock title="Headers" value={occurrence.requestHeaders} emptyText="No request headers captured." />
                  <JsonBlock title="Body" value={occurrence.requestBody} emptyText="No request body captured." />
                </div>
              </TabPanel>
              <TabPanel id="response" className="pt-4">
                <div className="space-y-6">
                  <JsonBlock title="Headers" value={occurrence.responseHeaders} emptyText="No response headers captured." />
                  <JsonBlock title="Body" value={occurrence.responseBody} emptyText="No response body captured." />
                </div>
              </TabPanel>
            </Tabs>
          )}
        </DialogContent>
        <DialogFooter>
          <Button variant="primary" onPress={() => onOpenChange(false)}>
            Done
          </Button>
        </DialogFooter>
      </Dialog>
    </DialogTrigger>
  );
};
